
export class EndPoint {
private static eurekaServer: String = 'https://10.10.1.22:30807/zuul/';
private static ACD_NOTA: String = EndPoint.eurekaServer + 'acd-nota';
/**
 * @param {?} codigoEmpresa
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @return {?}
 */
public static buscaComboTurmaTradicional(codigoEmpresa: number, codigoInstituicao: number, rgmAluno: number): any {
        return this.ACD_NOTA
            + '/consulta/nota/tradicional/combo/' + codigoEmpresa
            + "/" + codigoInstituicao
            + "/" + rgmAluno;
    }
/**
 * @param {?} codigoEmpresa
 * @param {?} codigoInstituicao
 * @param {?} codigoAluno
 * @param {?} codigoTurma
 * @return {?}
 */
public static buscaDisciplinaResultado(codigoEmpresa: number, codigoInstituicao: number, codigoAluno: number, codigoTurma: number): any {
        return this.ACD_NOTA
            + '/consulta/nota/tradicional/disciplina/resultado/' + codigoEmpresa
            + "/" + codigoInstituicao
            + "/" + codigoAluno
            + "/" + codigoTurma
            ;
    }
/**
 * @param {?} codigoOferta
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @return {?}
 */
public static buscaParciais(codigoOferta: number, codigoInstituicao: number, rgmAluno: number): any {
        return this.ACD_NOTA
            + '/consulta/nota/tradicional/parciais/' + codigoOferta
            + "/" + rgmAluno
            + "/" + codigoInstituicao
            ;
    }
/**
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @param {?} codigoEmpresa
 * @return {?}
 */
public static buscaComboTurmaCombo(codigoInstituicao: number, rgmAluno: number, codigoEmpresa: number): any {
        return this.ACD_NOTA
            + '/consulta/nota/pos/lista/' + codigoInstituicao
            + "/" + rgmAluno
            + "/" + codigoEmpresa;
    }
/**
 * @param {?} rgmAluno
 * @param {?} codigoInstituicao
 * @param {?} codigoEmpresa
 * @param {?} codigoTurma
 * @return {?}
 */
public static buscaBoletimPos(rgmAluno: number, codigoInstituicao: number, codigoEmpresa: number, codigoTurma: number): any {
        return this.ACD_NOTA
            + "/consulta/nota/pos/boletim/rgmAluno/" + rgmAluno
            + "/codigoInstituicao/" + codigoInstituicao
            + "/codigoEmpresa/" + codigoEmpresa
            + "/codigoTurma/" + codigoTurma
            ;
    }
/**
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @param {?} codigoEmpresa
 * @return {?}
 */
public static buscaComboAnoColegio(codigoInstituicao: number, rgmAluno: number, codigoEmpresa: number): any {
        return this.ACD_NOTA
            + '/nota/colegio/combo/' + codigoInstituicao
            + "/" + rgmAluno
            + "/" + codigoEmpresa
            ;
    }
/**
 * @param {?} codigoAluno
 * @param {?} codigoEmpresa
 * @param {?} codigoInstituicao
 * @param {?} codigoTurma
 * @return {?}
 */
public static buscaDisciplinasColegio(codigoAluno: number, codigoEmpresa: number, codigoInstituicao: number, codigoTurma: number): any {

        return this.ACD_NOTA
            + '/nota/colegio/media/nota/' + codigoAluno
            + "/" + codigoEmpresa
            + "/" + codigoInstituicao + "?turmas=" + codigoTurma
            ;
    }
/**
 * @param {?} codigoDisciplina
 * @param {?} codigoInstituicao
 * @param {?} codigoTurma
 * @param {?} rgmAluno
 * @param {?} seqNota
 * @return {?}
 */
public static buscaParcialColegio(
        codigoDisciplina: number,
        codigoInstituicao: number,
        codigoTurma: number,
        rgmAluno: number,
        seqNota: number,
    ): any {

        return this.ACD_NOTA
            + '/nota/colegio/parciais/' + codigoDisciplina
            + "/" + codigoInstituicao
            + "/" + codigoTurma
            + "/" + rgmAluno
            + "/" + seqNota
            ;
    }
/**
 * @param {?} codigoInstituicao
 * @param {?} codigoCurso
 * @return {?}
 */
public static buscaBloqueioNotaColegio(codigoInstituicao: number, codigoCurso: number): any {
        
        return this.ACD_NOTA
            + '/nota/colegio/curso/bloqueado/' + codigoInstituicao
            + "/" + codigoCurso
            ;
    }
/**
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @param {?} codigoEmpresa
 * @return {?}
 */
public static buscaComboTurmaMedicina(codigoInstituicao: number, rgmAluno: number, codigoEmpresa: number): any {
        return this.ACD_NOTA
            + '/notaPbl/historico/semestral/' + codigoInstituicao
            + "/" + rgmAluno
            + "/" + codigoEmpresa
            ;
    }
/**
 * @param {?} codigoInstituicao
 * @param {?} codigoAluno
 * @param {?} codigoTurma
 * @return {?}
 */
public static buscaDisciplinasMedicina(codigoInstituicao: number, codigoAluno: number, codigoTurma: number): any {
        return this.ACD_NOTA
            + '/notaPbl/disciplina/' + codigoInstituicao
            + "/" + codigoAluno
            + "/" + codigoTurma
            ;
    }
/**
 * @param {?} codigoDisciplina
 * @param {?} idOferta
 * @param {?} codigoAluno
 * @param {?} codigoInstituicao
 * @param {?} codigoTurma
 * @return {?}
 */
public static buscaSubDisciplinasMedicina(codigoDisciplina: number, idOferta: number, codigoAluno: number, codigoInstituicao: number, codigoTurma: number) : any {
        return this.ACD_NOTA
        + '/notaPbl/subdisciplina/' + codigoDisciplina
        + "/" + idOferta
        + "/" + codigoAluno
        + "/" + codigoInstituicao
        + "/" + codigoTurma
        ;
    }
}

function EndPoint_tsickle_Closure_declarations() {
/** @type {?} */
EndPoint.eurekaServer;
/** @type {?} */
EndPoint.ACD_NOTA;
}

